import { useEffect, useState } from "react";
import { http } from "../lib/api";
import { CopyBtn } from "../components/CopyBtn";

export const Techniques = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { http.get("/techniques").then((r) => setItems(r.data)); }, []);

  return (
    <div data-testid="techniques-page" className="mx-auto max-w-6xl px-6 py-16">
      <div className="mb-10">
        <div className="text-[10px] uppercase tracking-[0.3em] text-[color:var(--accent-matrix)] mb-3">// module.techniques</div>
        <h1 className="font-display font-bold text-4xl sm:text-5xl tracking-tight">the seven techniques</h1>
        <p className="text-neutral-400 mt-4 max-w-2xl">
          Every advanced prompt is built from these primitives. Learn them once, apply them forever.
        </p>
      </div>

      <div className="space-y-px bg-white/10 border border-white/10">
        {items.map((t, idx) => (
          <div key={t.id} data-testid={`technique-${t.id}`} className="bg-[#0a0a0a] p-8 md:p-10 grid grid-cols-1 md:grid-cols-[80px_1fr] gap-6">
            <div className="font-display font-bold text-3xl text-[color:var(--accent-amber)]">
              {String(idx + 1).padStart(2, "0")}
            </div>
            <div>
              <h3 className="font-display font-bold text-xl mb-2">{t.name}</h3>
              <p className="text-sm text-neutral-400 mb-4">{t.summary}</p>
              <div className="text-[10px] uppercase tracking-[0.3em] text-neutral-500 mb-2 flex items-center justify-between">
                <span>template</span>
                <CopyBtn text={t.template} testId={`copy-tech-${t.id}`} />
              </div>
              <pre className="bg-black border border-white/10 p-4 text-xs whitespace-pre-wrap text-neutral-200 mb-4">{t.template}</pre>
              <div className="text-[10px] uppercase tracking-[0.3em] text-[color:var(--accent-matrix)] mb-1">why it works</div>
              <p className="text-sm text-neutral-300">{t.why}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
